import {useState} from 'react';
import {animationFolders, gameFolders, profWork} from './ProjectEntries';
import "./ProjectsPage.css"

// I don't like is the amount of loop functions; ProjectPage uses 2 map()s, Row uses a for, Entries uses forEach and map. Granted some of these are called on clicks.

function ProjectPage(){
    return(
        <section name="Projects Page" className="page-container">
            <div id="folders">
                <FolderRow sectionName={"[ W o r k ]"} folders={profWork}/>
                <hr/>
                <FolderRow sectionName={"[ A n i m a t i o n s ]"} folders={animationFolders}/>
                <hr/>
                <FolderRow sectionName={"[ G a m e s ]"} folders={gameFolders}/>
            </div>
            <div id="foldersContent">
                {Object.keys(profWork).map((key) => ( <FolderContents key={key} folderProps={profWork[key]}/>))}
                {Object.keys(animationFolders).map((key) => ( <FolderContents key={key} folderProps={animationFolders[key]}/>))}
                {Object.keys(gameFolders).map((key) => ( <FolderContents key={key} folderProps={gameFolders[key]}/>))}
            </div>
        </section>
    );
}

// Creates a section that holds rows created per entry
function FolderRow({sectionName, folders}){
    const rows = [];
    const columnCount = 4;
    const foldersSize = Object.keys(folders).length;

    for (let i = 0; i < foldersSize; i += columnCount) {
        rows.push(<FolderEntries key={i} sectionName={sectionName} folders={folders} range={[i, i < foldersSize ? i+columnCount : foldersSize]}/>);
    }
    return(
        <section name={sectionName}>
            {rows}
        </section>
    );
}

function FolderEntries({sectionName, folders, range}){
    let sliced = Object.keys(folders).slice(range[0], range[1]);
    const onFolderClicked = (contentsID) => {
        showFolderContents(true);
        // Set all that is not the corresponding contents to display: none, otherwise set to display: block
        const descpritions = document.getElementsByClassName("folder-description");
        Array.prototype.forEach.call(descpritions, function(element){ element.style.display = element.id !== contentsID ? "none" : "block"; })
    }

    return(
        <div className="row justify-content-center">
            <h3>{sectionName}</h3>
            {sliced.map((key) => (
                <Folder key={key.toString()} folderProps={folders[key]} clicked={onFolderClicked} />
            ))}
        </div>
    );
}

function Folder({folderProps, clicked}){
    function onClickHandler(e){
        e.preventDefault();
        clicked(folderProps.title);
    }
    return (
        <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 text-center">
            <div className='project-thumbnail-container'>
                <a onClick={onClickHandler}>
                    <picture>
                        <source srcSet={folderProps.thumbnail} type="image/jpeg" media="(min-width: 40em)"/>
                        <img src={folderProps.image} className="project-thumbnail" title={folderProps.title} alt={folderProps.title}/>
                    </picture>
                    <h4>{folderProps.title}</h4>
                </a>
                <div className='overlay'></div>
            </div>
        </div>
    );
}

function FolderContents({folderProps}){
    let displayStyle = {display: "none"}
    function hideContents(e){
        e.preventDefault();
        showFolderContents(false);
    }
    function CheckType(){
        var result;
        console.log(folderProps.type)
        switch (folderProps.type){
            case "gallery":
                result = <GalleryContents folderProps={folderProps}/>
                break;
            case "standard":
                result = <StandardContents folderProps={folderProps}/>
                break;
         }
         return result;
    }
    return(
        <div id={folderProps.title} className="row text-center folder-description" style={displayStyle}>
            <div className="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1"></div>
            <div className="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10">
                <a onClick={hideContents}><h3>{folderProps.title}</h3></a>
                <hr/>
                <CheckType/>
            </div>
            <div className="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1"><a className="folder-close-button" onClick={hideContents}>✖</a></div>
        </div>
    );
}

function StandardContents({folderProps}){
    return(
        <>
            <p>{folderProps.description}</p>
            <a href={folderProps.link} target='_blank'>
                <img className="project-thumbnail"src={folderProps.image}/>
            </a>
            <div className='TopSeperator'></div>
        </>
    );
}

function GalleryContents({folderProps}){
    function BannerSection({banner}){
        console.log(banner)
        return(
            <>
                <p>{banner.description}</p>
                <img className="project-thumbnail"src={banner.image}/>
                <hr/>
            </>
        );
    }

    return(
        <>
            {Object.keys(folderProps.images).map((key) => ( <BannerSection key={key} banner={folderProps.images[key]}/>))}
        </>
    );
}


//Toggles on the content view of the folder's contents
function showFolderContents(displayOption){
    document.getElementById("folders").style.display = displayOption ? "none" : "block";
    document.getElementById("foldersContent").style.display = displayOption ? "block" : "none";
}

export default ProjectPage